import React, { useCallback } from 'react';
import { useRouter } from 'next/router';

import PolicyPage from '../components/PolicyPage';

const aboutText = `

supercooldata is an educational web app to teach knowledge workers how to analyze their own data with SQL. Get your company data driven by building your own SQL analytics course just for your company’s data. Teach your product, marketing, sales and finance teams how to analyze their own data with role specific tutorials. Don’t limit them by what an analytics tool can do. Don’t make them wait for answers from overloaded data analysts.

Learn analytics on the go with our mobile responsive experience. Receive direct WhatsApp support from our team of data analysts. Get your team up to speed with SQL and analytics in no time.
`;

const About: React.FC = () => {
  const router = useRouter();

  const onClickGetStarted = useCallback(() => {
    router.push('/dashboard');
  }, [router]);

  return (
    <PolicyPage
      page="about"
      title="About supercooldata"
      text={aboutText}
      onClickHeaderCta={onClickGetStarted}
    />
  );
};

export default About;
